/**
 * Authorization Roles
 */
const authRoles = {
  admin: ['SUPER_ADMIN'],
  staff: ['ADMIN', 'MODERATOR',"DOCTOR","RECEPTION", "DESIGNER"],
  user: ['admin', 'MODERATOR', 'USER'],
  onlyGuest: [],
};

export default authRoles;
